import { getActionTypeFromInstance, NGXS_PLUGINS } from "@ngxs/store";

import { Logout, authStateDefaults } from "@fitscovery/auth/data-access";
import { userStateDefaults } from "@fitscovery/user/data-access";

function partnerWebLogoutPlugin(state: any, action: any, next: any) {

  if (getActionTypeFromInstance(action) === Logout.type) {
    state = {
      auth: authStateDefaults,
      user: userStateDefaults,
      partner: state.partner,
      events: state.events,
      membership: state.membership,
      payment: state.payment,

      workout: state.workout,
      program: state.program,
      
      partnerMembershipSubscription: state.partnerMembershipSubscription,
      posts: state.posts,
      postUserPoints: state.postUserPoints,

      domain_schedules: state.domain_schedules,
      application: state.application,
      shared: state.shared
    };
  }

  return next(state, action);
}

export const PartnerWebLogoutPluginProvider = {
  provide: NGXS_PLUGINS,
  useValue: partnerWebLogoutPlugin,
  multi: true
};
